import React, { useEffect } from "react";

import logger from "../../../utils/logger";
import {
  REACT_APP_ENABLE_APP_INSIGHTS,
  REACT_APP_VERSION,
} from "../../../configs";
import useTrackEvent from "../../../utils/hooks/use-track-app-event";
import { APP_INSIGHTS_EVENTS } from "../../../constants";

const AppContent = ({ children }) => {
  const trackEvent = useTrackEvent();

  useEffect(() => {
    if (REACT_APP_ENABLE_APP_INSIGHTS) {
      trackEvent(APP_INSIGHTS_EVENTS.OPEN_APPLICATION);
    }
  });

  return (
    <div className="react-app">
      {logger.info("v", REACT_APP_VERSION)}
      <div className="react-app-content">{children}</div>
    </div>
  );
};

export default AppContent;
